"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _iconsReact = require("../../../icons-react");
var StyledCheckIcon = (0, _styledComponents["default"])(_iconsReact.Check).withConfig({
  displayName: "HotelCardViewedLabel__StyledCheckIcon",
  componentId: "sc-19zrndk-0"
})(["width:14px;height:10px;stroke-width:1;margin-right:3px;path{stroke:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
});
var StyledViewedLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardViewedLabel__StyledViewedLabel",
  componentId: "sc-19zrndk-1"
})(["font-size:14px;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var HotelCardViewedLabel = function HotelCardViewedLabel() {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledViewedLabel, null, /*#__PURE__*/_react["default"].createElement(StyledCheckIcon, null), t('hotelcard.card.label'));
};
var _default = exports["default"] = HotelCardViewedLabel;